export const Logout = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><path d="m24,3v18c0,1.654-1.346,3-3,3h-5v-2h5c.551,0,1-.449,1-1V3c0-.551-.449-1-1-1h-5V0h5c1.654,0,3,1.346,3,3Zm-15,18.273v-5.273H0v-8h9V2.729l8.28,7.576c.476.473.721,1.063.72,1.691,0,.627-.246,1.217-.691,1.66l-8.309,7.616Zm2-7.273v2.727l4.928-4.517c.059-.059.072-.162.072-.215,0-.054-.013-.156-.101-.244l-4.899-4.481v2.73H2v4h9Z" fill={props.color || '#000'} /></svg>
    );
};
export const ArrowUp = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><g id="_01_align_center" data-name="01 align center"><path d="M22.586,18.148,12.707,8.269a1.021,1.021,0,0,0-1.414,0L1.42,18.142.006,16.728,9.879,6.855a3.073,3.073,0,0,1,4.243,0L24,16.734Z" fill={props.color} /></g></svg>
    );
};
export const ArrowDown = (props) => {
    return (
        <svg
            {...props}
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"><g id="_01_align_center" data-name="01 align center"><path d="M22.586,5.929l-9.879,9.879a1.021,1.021,0,0,1-1.414,0L1.42,5.934.006,7.348l9.873,9.874a3.075,3.075,0,0,0,4.243,0L24,7.343Z" fill={props.color} /></g></svg>
    );
};